import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/clientProviders.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap/scss/bootstrap.scss");
;
import(/* webpackMode: "eager" */ "/app/public/css/plugins/feature.css");
;
import(/* webpackMode: "eager" */ "/app/public/css/plugins/fontawesome-all.min.css");
;
import(/* webpackMode: "eager" */ "/app/public/css/plugins/animation.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/sal.js/dist/sal.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/slick-carousel/slick/slick-theme.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tooltip/dist/react-tooltip.min.css");
;
import(/* webpackMode: "eager" */ "/app/public/scss/style.scss");
